import { debounce } from "throttle-debounce";
import { appDomain } from "../../domain/AppDomain";
import { ICalendar } from "../../domain/calendars/ICalendar";
import { getDaysOfMonth } from "../../helpers/dateHelpers";
import { BaseComponent } from "../core/BaseComponent";
import "./AbsenceMonth.css";
import { AbsenceMonthRow } from "./AbsenceMonthRow";
import { AbsenceMonthTableHeader } from "./AbsenceMonthTableHeader";

interface AbsenceMonthTableProps {
    date: Date;
    onLoading: (isLoading: boolean) => void;
}
export class AbsenceMonthTable extends BaseComponent<AbsenceMonthTableProps, any> {
    constructor(props: AbsenceMonthTableProps) {
        super(props);
        this.state = {
            available: 0,
            total: 0,
            updated: new Date()
        };
    }
    componentDidMount() {
        this.getAttentionDays();
    }

    componentDidUpdate() {
        if (this.state.isChanged) {
            this.setStateWhenMounted({ isChanged: false })
            this.loadWithDebounce();
        }
    }

    static getDerivedStateFromProps(nextProps: AbsenceMonthTableProps, prevState: any): any {
        if (prevState.date !== nextProps.date) {
            return { date: nextProps.date, isChanged: true };
        }
        return null;
    }

    private loadWithDebounce: Function = debounce(500, () => this.updateAbsences());

    async updateAbsences() {
        this.props.onLoading(true);
        if (!this.state.allActiveEmployees) {
            this.setStateWhenMounted({ allActiveEmployees: await appDomain.IEmployeeService.getEmployeeAbsenceInfos() });
        }

        const employeeAbsenceInfo = await appDomain.IEmployeeAbsenceService.getAbsenceForMonth(this.props.date);
        this.state.allActiveEmployees.forEach((calendar: ICalendar) => {
            const foundItem = employeeAbsenceInfo.find(x => x.id === calendar.id);
            if (foundItem) {
                calendar.calendarEvents = foundItem.calendarEvents;
            }
        });
        this.setStateWhenMounted({});
        this.props.onLoading(false);
    }

    async getAttentionDays() {
        const attentionDays = await appDomain.IAttentionDayService.requestAttentionDays();
        this.setStateWhenMounted({ attentionDays });
    }
    render() {
        const daysOfMonth = getDaysOfMonth(this.props.date);
        const colWidth = (80 / daysOfMonth.length) + "%";
        const userId = appDomain.IAuthenticationService.getUserEmail();
        const tableRows: JSX.Element[] = [];
        if (this.state && this.state.allActiveEmployees) {
            const employee = this.state.allActiveEmployees as ICalendar[];
            employee.forEach(a => tableRows.push(<AbsenceMonthRow key={`${a.id}`} calendar={a} daysOfMonth={daysOfMonth} colWidth={colWidth} isCurrentUser={userId === a.id} />));
        }

        return (
            <div>
                <table className="monthoverview">
                    <AbsenceMonthTableHeader month={this.props.date} daysOfMonth={daysOfMonth} colWidth={colWidth} allAttentionDays={this.state.attentionDays} />
                    <tbody>
                        {tableRows}
                    </tbody>
                </table>
            </div>
        )
    }
}
